export default "__VITE_ASSET__sBWJM8PM__"